var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartNotEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1433 23.9751C11.6418 23.9751 12.9097 25.243 12.9097 26.7415C12.9097 28.2975 11.6418 29.5078 10.1433 29.5078C8.58723 29.5078 7.37695 28.2975 7.37695 26.7415C7.37695 25.243 8.58723 23.9751 10.1433 23.9751ZM32.7929 2.59346C33.1387 3.05452 33.2539 3.68848 33.081 4.20717L29.9112 15.2726C29.6807 16.0795 28.9891 16.5981 28.1823 16.5981H9.79752L10.3162 19.3645H28.1246C28.8739 19.3645 29.5078 19.9985 29.5078 20.7477C29.5078 21.5545 28.8739 22.1309 28.1246 22.1309H9.22119C8.5296 22.1309 7.95328 21.6698 7.83801 21.0358L4.38007 2.76636H1.38318C0.576324 2.76636 0 2.19003 0 1.38318C0 0.633957 0.576324 0 1.38318 0H5.53271C6.16667 0 6.743 0.518692 6.85826 1.15265L6.97353 1.84424L7.54985 4.6106L9.27882 13.8318H27.4907L30.0841 4.6106L30.3759 3.70915C30.748 2.55983 32.068 1.62703 32.7929 2.59346V2.59346ZM26.7415 23.9751C28.2399 23.9751 29.5078 25.243 29.5078 26.7415C29.5078 28.2975 28.2399 29.5078 26.7415 29.5078C25.1854 29.5078 23.9751 28.2975 23.9751 26.7415C23.9751 25.243 25.1854 23.9751 26.7415 23.9751Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartNotEmpty);
export default __webpack_public_path__ + "static/media/cart-not-empty.d6fa9fa20aef3988a10ee168c3fcfeb2.svg";
export { ForwardRef as ReactComponent };